import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs';

declare var $: any;

@Injectable()
export class BackendSocketService {
  public getBbMarketRate = (id) => {
    return Observable.create((observer) => {
      this.socket.on('api-data', (message) => {
        observer.next(message);
      });
    });
  };
  //private url = 'https://sslmkt.rdsconn.com/';
  private url = 'https://schart.99sports.games';
  //private url = "https://rd.getlivefeed.xyz/";
  private socket;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private location: Location,
  ) {
    this.socket = io(this.url, {
      query: {
        api_token_temp: 'android',
      },
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 500,
      reconnectionDelayMax: 1000,
      reconnectionAttempts: Infinity,
      transports: ['websocket'],
    });
    //this.socket.emit('join-room', 'room2');
  }

  //Join room function
  joinRoom(roomId) {
    //console.log(roomId);
    this.socket.emit('join-room', roomId);
  }
  leaveRoom(roomId) {
    this.socket.emit('leave-room', roomId);
  }

  disconnect() {
    this.socket.disconnect(0);
  }

  connect() {
    this.socket.connect(0);
  }

  setInstrument(roomId) {
    this.socket.emit('set-instrument', roomId);
  }
  leaveAllRoom() {
    this.socket.leaveAll();
  }

  detailInstrument(roomId) {
    this.socket.emit('set-instrument', roomId);
  }

  public getInstrument = () => {
    return Observable.create((observer) => {
      this.socket.on('get-instrument', (message) => {
        observer.next(message);
      });
    });
  };
}
